import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Button,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import ConfirmButton from '../confirm-button';
import styles from './styles.css';

class DeleteCustomFieldButton extends Component {
  constructor() {
    super();
    this.state = {
      deleting: false,
    };
    this.cancel = this.cancel.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.showWarning = this.showWarning.bind(this);
  }
  cancel() {
    this.setState({ show: false });
  }
  confirmDelete() {
    const { deleting } = this.state;
    if (!deleting) {
      this.setState({ deleting: true });
      this.props.requestDeleteCustomMeta()
        .then(
          () => {
            this.setState({ deleting: false });
          },
          () => {
            this.setState({ deleting: false });
          },
        );
    }
  }
  showWarning() {
    this.setState({ show: true });
  }

  renderModal() {
    const { meta } = this.props;
    const { deleting, show } = this.state;
    const disabled = deleting;

    return (
      <Modal backdropClassName={styles.warningBackdrop} key="modal" bsSize="sm" show={show} onHide={this.cancel}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger"><Fa name="exclamation-triangle" /> Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="well well-sm well-danger">
            <p><strong>You are about to delete custom meta field named <code>{meta.label}</code>.</strong></p>
            <p>
              Removing a custom meta field will also remove any table columns that link to this cutom meta field
              as well as all the associated custom data.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <div className="pull-left">
              <Button bsStyle="link" onClick={this.cancel}>Cancel</Button>
            </div>
            <div className="pull-right">
              <ConfirmButton
                disabled={disabled}
                confirmMessage="Sure?"
                confirmStyle="danger"
                onConfirm={this.confirmDelete}
              >
                {deleting && <Fa name="spinner" spin className="text-muted" />}
                {!deleting && <span><Fa name="trash" /> Delete</span>}
              </ConfirmButton>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }


  render() {
    const { disabled } = this.props;
    return [
      (
        <Button
          key="button"
          bsStyle="link"
          onClick={this.showWarning}
          disabled={disabled}
        >
          <span className="text-danger"><Fa name="trash" /> Delete Custom Meta</span>
        </Button>
      ),
      this.renderModal(),
    ];
  }
}


DeleteCustomFieldButton.propTypes = {
  disabled: PropTypes.bool,
  meta: PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  requestDeleteCustomMeta: PropTypes.func,
};
DeleteCustomFieldButton.defaultProps = {
  disabled: false,
  requestDeleteCustomMeta: () => Promise.reject(new Error('need handler')),
};
export default DeleteCustomFieldButton;
